// hooks/useLogout.js
import { useCart } from '../context/CartContext';

const useLogout = (setIsLoggedIn) => {
  const { setCartItems } = useCart();

  return () => {
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('account_id');
    localStorage.clear();
    sessionStorage.clear();

    // ✅ Clear cart
    setCartItems([]);
    setIsLoggedIn(false);

    // Optional: Unregister service workers
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
          registration.unregister().then(success => {
            console.log(success ? 'SW unregistered' : 'SW unreg failed');
          });
        });
      });
    }
  };
};

export default useLogout;
